import { render, staticRenderFns } from "./childIcon.vue?vue&type=template&id=3b90004f"
import script from "./childIcon.vue?vue&type=script&lang=js"
export * from "./childIcon.vue?vue&type=script&lang=js"
import style0 from "./childIcon.vue?vue&type=style&index=0&id=3b90004f&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports